import {
  FETCH_ACCOUNT_LIST,
  FETCH_ACCOUNT_LIST_ERROR,
  SET_ACCOUNT_LIST,
  CREATE_NEW_ACCOUNT,
  CREATE_NEW_ACCOUNT_SUCCESS,
  CREATE_NEW_ACCOUNT_FAILED,
  FETCH_ACCOUNT_DETAILS,
  FETCH_ACCOUNT_DETAILS_ERROR,
  SET_ACCOUNT_DETAILS,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILED,
  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_PERSONAL_DETAILS,
  UPDATE_PERSONAL_DETAILS_SUCCESS,
  UPDATE_PERSONAL_DETAILS_FAILED,
  UPDATE_ACCOUNT_FAILED,
  FETCH_ACCOUNT_PERMISSIONS,
  FETCH_ACCOUNT_PERMISSIONS_ERROR,
  SET_ACCOUNT_PERMISSIONS,
  ASSOCIATE_ROLES_WITH_ACCOUNT,
  ASSOCIATE_ROLES_WITH_ACCOUNT_SUCCESS,
  ASSOCIATE_ROLES_WITH_ACCOUNT_FAILED,
  FETCH_ACCOUNT_OVERVIEW,
  FETCH_ACCOUNT_OVERVIEW_ERROR,
  SET_ACCOUNT_OVERVIEW,
  RESET_ACCOUNT_PASSWORD,
  RESET_ACCOUNT_PASSWORD_SUCCESS,
  RESET_ACCOUNT_PASSWORD_FAILED,
  SERVER_STATUS_OK,
  SERVER_STATUS_ERROR,
  LOG_OUT,
} from '../constants';

const initialState = {
  accountListData: [],
  accountListLoaded: false,
  accountOverviewData: {},
  accountOverviewLoaded: false,
  personalDetailsDataLoaded: false,
  clientDataLoaded: false,
  userAccountsDataLoaded: false,
  createNewAccountInProgress: false,
  deleteAccountInProgress: false,
  updateAccountInProgress: false,
  updatePersonalDetailsInProgress: false,
  associateRolesWithAccountInProgress: false,
  resetAccountPasswordInProgress: false,
  serverStatus: {
    status: true,
    code: 200,
  },
};

const account = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case FETCH_ACCOUNT_LIST:
      return {
        ...state,
        accountListLoaded: false,
      };
    case FETCH_ACCOUNT_LIST_ERROR:
      return {
        ...state,
      };
    case SET_ACCOUNT_LIST:
      return {
        ...state,
        accountListData: action.data,
        accountListLoaded: true,
      };
    case FETCH_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetailsLoaded: true,
      };
    case FETCH_ACCOUNT_DETAILS_ERROR:
      return {
        ...state,
        accountDetailsLoaded: false,
      };
    case SET_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetailsData: action.data,
        accountDetailsLoaded: false,
      };
    case CREATE_NEW_ACCOUNT:
      return {
        ...state,
        createNewAccountInProgress: true,
        userAccountsDataLoaded: false,
      };
    case CREATE_NEW_ACCOUNT_SUCCESS:
      return {
        ...state,
        createNewAccountInProgress: false,
        // userAccountsDataLoaded: true,
      };
    case CREATE_NEW_ACCOUNT_FAILED:
      return {
        ...state,
        createNewAccountInProgress: false,
        userAccountsDataLoaded: true,
      };
    case DELETE_ACCOUNT:
      return {
        ...state,
        deleteAccountInProgress: true,
        userAccountsDataLoaded: false,
      };
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deleteAccountInProgress: false,
        // userAccountsDataLoaded: true,
      };
    case DELETE_ACCOUNT_FAILED:
      return {
        ...state,
        deleteAccountInProgress: false,
        userAccountsDataLoaded: true,
      };
    case UPDATE_ACCOUNT:
      return {
        ...state,
        updateAccountInProgress: true,
        userAccountsDataLoaded: false,
      };
    case UPDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        updateAccountInProgress: false,
        // userAccountsDataLoaded: true,
      };
    case UPDATE_ACCOUNT_FAILED:
      return {
        ...state,
        updateAccountInProgress: false,
        userAccountsDataLoaded: true,
      };
    case UPDATE_PERSONAL_DETAILS:
      return {
        ...state,
        updatePersonalDetailsInProgress: true,
        personalDetailsDataLoaded: false,
      };
    case UPDATE_PERSONAL_DETAILS_SUCCESS:
      return {
        ...state,
        updatePersonalDetailsInProgress: false,
        personalDetailsDataLoaded: true,
        accountOverviewData: {
          ...state.accountOverviewData,
          account: action.data,
        },
      };
    case UPDATE_PERSONAL_DETAILS_FAILED:
      return {
        ...state,
        updatePersonalDetailsInProgress: false,
        personalDetailsDataLoaded: true,
      };
    case FETCH_ACCOUNT_PERMISSIONS:
      return {
        ...state,
        accountPermissionsLoaded: true,
      };
    case FETCH_ACCOUNT_PERMISSIONS_ERROR:
      return {
        ...state,
        accountPermissionsLoaded: false,
      };
    case SET_ACCOUNT_PERMISSIONS:
      return {
        ...state,
        accountPermissionsData: action.data,
        accountPermissionsLoaded: false,
      };
    case ASSOCIATE_ROLES_WITH_ACCOUNT:
      return {
        ...state,
        associateRolesWithAccountInProgress: true,
      };
    case ASSOCIATE_ROLES_WITH_ACCOUNT_SUCCESS:
      return {
        ...state,
        associateRolesWithAccountInProgress: false,
      };
    case ASSOCIATE_ROLES_WITH_ACCOUNT_FAILED:
      return {
        ...state,
        associateRolesWithAccountInProgress: false,
      };
    case FETCH_ACCOUNT_OVERVIEW:
      return {
        ...state,
        accountOverviewLoaded: false,
      };
    case FETCH_ACCOUNT_OVERVIEW_ERROR:
      return {
        ...state,
        accountOverviewLoaded: false,
      };
    case SET_ACCOUNT_OVERVIEW:
      return {
        ...state,
        accountOverviewData: action.data,
        accountOverviewLoaded: true,
        personalDetailsDataLoaded: !!action.data.account,
        clientDataLoaded: !!action.data.client,
        userAccountsDataLoaded: !!action.data.accounts,
      };
    case RESET_ACCOUNT_PASSWORD:
      return {
        ...state,
        resetAccountPasswordInProgress: true,
      };
    case RESET_ACCOUNT_PASSWORD_SUCCESS:
      return {
        ...state,
        resetAccountPasswordInProgress: false,
      };
    case RESET_ACCOUNT_PASSWORD_FAILED:
      return {
        ...state,
        resetAccountPasswordInProgress: false,
      };
    case SERVER_STATUS_OK:
      return {
        ...state,
      };
    case SERVER_STATUS_ERROR:
      return {
        ...state,
        serverStatus: {
          status: false,
          code: action.error.status,
        },
      };

    default:
      return {
        ...state,
      };
  }
};

export default account;
